export const FORGET_PASS_USER_ID_KEY = "user_id_forget_pass";
export const FORGET_PASS_EMAIL_KEY = "email_forget_pass";
